import React from 'react';
import NotificationsIndexPage from '../notifications_index_page/NotificationsIndexPage';
import {
	BUYER_FILTER_STATUS_NOTIFICATION_TYPES_MAP,
	SUPPLIER_FILTER_STATUS_NOTIFICATION_TYPES_MAP,
	UNREAD_NOTIFICATION_TYPES,
} from '../../utils/NotificationUtils';
import { connect } from 'react-redux';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	userNotificationsRestCrudThunksForBuyer,
	userNotificationsRestCrudThunksForSupplier,
} from '../../thunks/user_notifications_thunks';

function NotificationsStatusUpdates({
	userType,
	fetchUserNotificationsCountForBuyer,
	fetchUserNotificationsCountForSupplier,
}) {
	const NOTIFICATION_STATUS_UPDATES_TYPES =
		userType === ROLE_TYPES.BUYER
			? BUYER_FILTER_STATUS_NOTIFICATION_TYPES_MAP
			: SUPPLIER_FILTER_STATUS_NOTIFICATION_TYPES_MAP;

	const fetchUserNotificationsCount =
		userType === ROLE_TYPES.BUYER
			? fetchUserNotificationsCountForBuyer
			: fetchUserNotificationsCountForSupplier;

	return (
		<NotificationsIndexPage
			key={'NotificationsStatusUpdates'}
			preAppliedFilters={{
				hasSeen: false,
			}}
			notificationTypes={NOTIFICATION_STATUS_UPDATES_TYPES.map((filter) => {
				if (filter.children && filter.children.length > 0) {
					return filter.children.map((child) => child.key);
				}
				return filter.key;
			}).flat()}
			typeFilters={NOTIFICATION_STATUS_UPDATES_TYPES}
			onNotificationClick={() => {
				fetchUserNotificationsCount(UNREAD_NOTIFICATION_TYPES, 'TASKS_NOTIFICATIONS');
			}}
		/>
	);
}

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	userType: state.session.userType,
});

const mapDispatchToProps = (dispatch) => ({
	fetchUserNotificationsCountForBuyer: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForBuyer.countBy(params, countName)),
	fetchUserNotificationsCountForSupplier: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForSupplier.countBy(params, countName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsStatusUpdates);
